import { ReportingTermRI } from '../rest-interfaces/reporting-term-ri';
import { ReportingTerm } from '../models/reporting-term';
import { ReportingTermWrapper } from '../models/reporting-term-wrapper';
import { TreeSort } from './tree-sort';
import {DateUtil} from './date-util';

export namespace ReportingTermSort {
  export function sortReportingTerms(terms: Array<ReportingTermRI>, allowDuplicates = false, sortType = TreeSort.TreeSortType.PRE_ORDER): Array<ReportingTermRI> {
    let allReportingTerms: Array<ReportingTermWrapper> = [];

    terms.forEach((term: ReportingTermRI) => {
      let rtTermIf = new ReportingTerm(term);
      allReportingTerms.push(new ReportingTermWrapper(rtTermIf));
    });

    if (!allowDuplicates) {
      allReportingTerms = mergeDuplicateNamedTermbins(allReportingTerms);
    }
    TreeSort.sortTreesPostOrder(allReportingTerms);

    for (let i = 0; i < allReportingTerms.length; i++) {
      let child: ReportingTermWrapper = allReportingTerms[i];
      for (let i1 = i + 1; i1 < allReportingTerms.length; i1++) {
        let possibleParent: ReportingTermWrapper = allReportingTerms[i1];
        if (DateUtil.dateRangeIsContained(child.getStartDate(), child.getEndDate(), possibleParent.getStartDate(), possibleParent.getEndDate())) {
          child.setParent(possibleParent);
          break;
        }
      }
    }

    let rootTerms: Array<ReportingTermWrapper> = [];
    for (let possibleRoot of allReportingTerms) {
      if (possibleRoot.isRoot()) {
        rootTerms.push(new ReportingTermWrapper(possibleRoot, possibleRoot.getChildren()));
      }
    }

    let reportingTerms: Array<ReportingTermRI> = [];
    let sortedTermWrappers = TreeSort.getSortedTreesUsing(rootTerms, sortType);
    for (let termWrapper of sortedTermWrappers) {
      reportingTerms.push({
        uid: termWrapper.getUid(),
        schedulingTermUid: termWrapper.getSchedulingTermUid(),
        reportingTermName: termWrapper.getReportingTermName(),
        startDate: termWrapper.getStartDate(),
        endDate: termWrapper.getEndDate()
      });
    }

    return reportingTerms;
  }

  function mergeDuplicateNamedTermbins(termWrappers: Array<ReportingTermWrapper>): Array<ReportingTermWrapper> {
    let merged: Map<string, ReportingTermWrapper> = new Map<string, ReportingTermWrapper>();

    for (let wrapper of termWrappers) {
      let value = merged.get(wrapper.getReportingTermName());
      if (value != null) {
        if (DateUtil.isAfter(value.getStartDate(), wrapper.getEndDate())) {
          value.setStartDate(wrapper.getStartDate());
        }
        if (DateUtil.isBefore(value.getEndDate(), wrapper.getEndDate())) {
          value.setEndDate(wrapper.getEndDate());
        }
      } else {
        merged.set(wrapper.getReportingTermName(), new ReportingTermWrapper(wrapper));
      }
    }

    return Array.from(merged.values());
  }
}
